import { getAnyFromLocalizationMap } from '../../utility/lang-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import {
  cloneMap,
  DataModel,
  DataModelBuilder,
  isSameMap,
  mapToData,
  SerializationContext,
  SerializedData,
} from '../dto/dto.js';
import { Language } from './language.js';
import { FileReference } from './file-reference/file-reference.js';

export class LocalizedFileReference extends DataModel {
  static readonly TYPE_ID: string = '806fa3457b2645c58796d6ed99e9fb02';

  constructor(
    private readonly localizations: Map<Language, FileReference>,
  ) {
    super();
  }

  get $typeId() {
    return LocalizedFileReference.TYPE_ID;
  }

  get isEmpty(): boolean {
    return !this.isNotEmpty;
  }

  get isNotEmpty(): boolean {
    return this.localizations.size > 0;
  }

  static empty(): LocalizedFileReference {
    return new LocalizedFileReference(new Map<Language, FileReference>());
  }

  get(language: Language): FileReference | null {
    return this.localizations.get(language) ?? null;
  }

  getAny(language: Language | null = null): FileReference | null {
    return getAnyFromLocalizationMap(this.localizations, language);
  }

  static fromMap(context: SerializationContext, map: SerializedData): LocalizedFileReference {
    return new LocalizedFileReference(
        MapUtils.getMap(map, 'localizations', (k, v) => {
          return { key: <Language>k, value: context.fromData<FileReference>(v as SerializedData) };
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'localizations': mapToData<Language, FileReference>(this.localizations, (k, v) => {
        return { key: k.toString(), value: context.toData(v) };
      }),
    };
  }

  clone(): this {
    return new LocalizedFileReference(
        cloneMap<Language, FileReference>(this.localizations)
    ) as this;
  }

  isSame(other: LocalizedFileReference): boolean {
    if(other === this) {
      return true;
    }

    return isSameMap<Language, FileReference>(other.localizations, this.localizations);
  }
}

export class LocalizedFileReferenceBuilder extends DataModelBuilder<LocalizedFileReference> {
  build(context: SerializationContext, map: SerializedData): LocalizedFileReference {
    return LocalizedFileReference.fromMap(context, map);
  }
}
